//src/assets/scripts/other.js

import CommonJS from './common';
const common = new CommonJS();
common.init();